import React from "react";
import attachment from "../../images/icons/attachment-logo.svg";
import SendIcon from "@mui/icons-material/Send";
import "./Chat-Form.css";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";

function ChatForm({ setProgress, setIsUpdateImage, consultaId, tipo: tipoUsuario, uid, userName }) {
  const [inputMessage, setInputMessage] = React.useState("");
  const db = firebase.firestore();
  var storage = firebase.storage();

  const sendMessage = (tipo, url = "") => {
    if ((inputMessage.trim() !== "" && tipo === "text") || (url !== "" && tipo === "imagen")) {
      const currentDate = new Date();

      db.collection("videollamadas")
        .doc(consultaId)
        .collection("messages")
        .add({
          instante: currentDate,
          leido: true,
          mensaje: tipo === "text" ? inputMessage : "",
          tipo: tipo,
          url: tipo === "text" ? "" : url,
          userId: uid,
          userName,
          tipoUsuario: tipoUsuario,
        });
      setInputMessage("");
    }
  };

  const importD = () => {
    let input = document.createElement("input");
    input.type = "file";
    input.accept = "image/png, image/jpeg";
    input.onchange = (_this) => {
      let files = Array.from(input.files);
      console.log(files);
      const file = files[0];
      const storageRef = storage.ref(`videollamadas/${consultaId}/${file.name}`);
      const uploadTask = storageRef.put(file);
      setIsUpdateImage(true);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setProgress(progress);
        },
        (error) => {
          // Handle unsuccessful uploads
          console.log(error);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            sendMessage("imagen", downloadURL);
            console.log("File available at", downloadURL);
          });
        }
      );
    };
    input.click();
  };

  return (
    <div id="chat-form">
      <img src={attachment} alt="Add Attachment" height={20} onClick={importD} />
      <input
        value={inputMessage}
        type="text"
        placeholder="Escribe un mensaje"
        onChange={(e) => setInputMessage(e.target.value)}
        onKeyDown={(event) => {
          let unicode = event.key;
          if (unicode === "Enter") {
            sendMessage("text");
          }
        }}
      />
      <div className="cursor-aaaa">
        <SendIcon color="primary" height={20} onClick={() => sendMessage("text")} />
      </div>
    </div>
  );
}

export default ChatForm;
